import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Tabs } from "antd";
import { getT } from "../../../../_utils/intl";
import { LoginType } from "../../types";
import useStyles from "../../style";
import VerificationCodeLogin from "./VerificationCodeLogin";
import ForgotPassword from "./ForgotPassword";
import AccountLogin from "./AccountLogin";
import FeishuLogin from "./FeishuLogin";
const LoginPanel = (props) => {
  const {
    appName,
    loginTypes,
    onLogin,
    showForgotPassword,
    feishuParams,
    verificationRequest,
    onForgotPassword
  } = props;
  const t = getT();
  const loginModeMap = {
    [LoginType.Account]: t("login.type.account"),
    [LoginType.VerificationCode]: t("login.type.captcha"),
    [LoginType.Feishu]: t("login.type.feishu")
  };
  const { styles } = useStyles();
  const [type, setType] = useState(loginTypes[0] || LoginType.Account);
  const [forgotPassword, setForgotPassword] = useState(false);
  const switchForgotPassword = () => {
    setForgotPassword(!forgotPassword);
  };
  return /* @__PURE__ */ jsxs("div", { className: styles.rightContent, children: [
    /* @__PURE__ */ jsx("div", { className: styles.appName, children: appName }),
    /* @__PURE__ */ jsx("div", { children: forgotPassword ? /* @__PURE__ */ jsx(
      ForgotPassword,
      {
        goLogin: switchForgotPassword,
        verificationRequest,
        onForgotPassword
      }
    ) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Tabs,
        {
          activeKey: type,
          items: loginTypes.map((item) => ({
            key: item,
            label: loginModeMap[item]
          })),
          onChange: (tab) => setType(tab),
          centered: true
        }
      ),
      type === LoginType.Account && /* @__PURE__ */ jsx(
        AccountLogin,
        {
          showForgotPassword,
          onLogin,
          goForgotPassword: switchForgotPassword
        }
      ),
      type === LoginType.VerificationCode && /* @__PURE__ */ jsx(VerificationCodeLogin, {}),
      type === LoginType.Feishu && /* @__PURE__ */ jsx(FeishuLogin, { feishuParams })
    ] }) })
  ] });
};
var LoginPanel_default = LoginPanel;
export {
  LoginPanel_default as default
};
